import * as React from 'react';

const DashboardGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <g
                id="dashboard-graphic_svg__dashboard"
                transform="translate(24 32)"
            >
                <path
                    d="M48 0c26.51 0 48 21.64 48 48.333C96 60.447 91.725 71.517 84.414 80H11.586C4.276 71.518 0 60.447 0 48.333 0 21.64 21.49 0 48 0"
                    id="dashboard-graphic_svg__Fill-1"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M48 0c26.51 0 48 21.64 48 48.333C96 60.447 91.725 71.517 84.414 80H11.586C4.276 71.518 0 60.447 0 48.333 0 21.64 21.49 0 48 0z"
                    id="dashboard-graphic_svg__Stroke-3"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M11.586 48.333c0-20.25 16.304-36.666 36.414-36.666 20.11 0 36.414 16.416 36.414 36.666 0 6.682-3.31 15-6.62 20H18.206c-3.31-5-6.62-13.318-6.62-20"
                    id="dashboard-graphic_svg__Fill-5"
                    fill="#DBDAE3"
                    fillRule="nonzero"
                />
                <path
                    d="M48 50v18.333H18.207c-3.31-5-6.62-13.318-6.62-20 0-9.7 3.748-18.515 9.856-25.075L48 50z"
                    id="dashboard-graphic_svg__Fill-7"
                    fill="#F05537"
                    fillRule="nonzero"
                />
                <path
                    d="M44.69 45L22.254 22.408"
                    id="dashboard-graphic_svg__Stroke-9"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M43.034 48.333c0 2.76 2.225 5 4.966 5s4.966-2.24 4.966-5-2.225-5-4.966-5-4.966 2.24-4.966 5"
                    id="dashboard-graphic_svg__Fill-11"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M43.034 48.333c0 2.76 2.225 5 4.966 5s4.966-2.24 4.966-5-2.225-5-4.966-5-4.966 2.24-4.966 5z"
                    id="dashboard-graphic_svg__Stroke-13"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M48 5v3.333"
                    id="dashboard-graphic_svg__Stroke-15"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M64.552 8.333v3.334"
                    id="dashboard-graphic_svg__Stroke-17"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M86.069 30v3.333"
                    id="dashboard-graphic_svg__Stroke-19"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M77.793 18.333v3.334"
                    id="dashboard-graphic_svg__Stroke-21"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M89.38 46.667V50"
                    id="dashboard-graphic_svg__Stroke-23"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M31.448 8.333v3.334"
                    id="dashboard-graphic_svg__Stroke-25"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M9.931 30v3.333"
                    id="dashboard-graphic_svg__Stroke-27"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M18.207 18.333v3.334"
                    id="dashboard-graphic_svg__Stroke-29"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
                <path
                    d="M6.62 46.667V50"
                    id="dashboard-graphic_svg__Stroke-31"
                    stroke="#1E0A3C"
                    strokeWidth={3.31}
                />
            </g>
        </g>
    </svg>
);

DashboardGraphicSvg.displayName = 'DashboardGraphicSvg';
export default DashboardGraphicSvg;
